<template>
    <div class="section">
        <div class="columns">
            <div class="column">
                <h1 class="title has-text-centered">Create new car</h1>
                <transition name="fade">
                    <div v-if="success" class="notification is-warning has-text-centered">
                        Car successfully created!
                    </div>
                </transition>
            </div>
        </div>
        <div class="columns">
            <div class="column is-4-desktop is-offset-2-desktop">
                <user-select></user-select>
                <manager-select></manager-select>
                <auction-input></auction-input>
                <lot-input></lot-input>
                <date-select></date-select>
                <score-input></score-input>
                <brand-input></brand-input>
                <model-input></model-input>
                <is-usd></is-usd>
            </div>
            <div class="column is-4-desktop">
                <year-input></year-input>
                <grade-input></grade-input>
                <mileage-input></mileage-input>
                <chassis-input></chassis-input>
                <color-input></color-input>
                <transmission-input></transmission-input>
                <displacement-input></displacement-input>
                <equipment-input></equipment-input>
                <result-input></result-input>
            </div>
        </div>
        <div class="columns">
            <div class="column has-text-centered">
                <button class="button" @click="backToGarage(userId)">
                    <span class="icon">
                        <i class="fas fa-arrow-left"></i>
                    </span>
                    <span>Garage</span>
                </button>
                <button class="button is-primary" :class="{ 'is-loading' : isLoading }" @click="createNewCar()">
                    <span class="icon">
                        <i class="fas fa-save"></i>
                    </span>
                    <span>Save Car</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import UserSelect from './Inputs/UserSelect'
    import ManagerSelect from './Inputs/ManagerSelect'
    import AuctionInput from './Inputs/AuctionInput'
    import LotInput from './Inputs/LotInput'
    import DateSelect from './Inputs/DateSelect'
    import ScoreInput from './Inputs/ScoreInput'
    import BrandInput from './Inputs/BrandInput'
    import ModelInput from './Inputs/ModelInput'
    import IsUsd from './Inputs/IsUsd'

    import YearInput from './Inputs/YearInput'
    import GradeInput from './Inputs/GradeInput'
    import MileageInput from './Inputs/MileageInput'
    import ChassisInput from './Inputs/ChassisInput'
    import ColorInput from './Inputs/ColorInput'
    import TransmissionInput from './Inputs/TransmissionInput'
    import DisplacementInput from './Inputs/DisplacementInput'
    import EquipmentInput from './Inputs/EquipmentInput'
    import ResultInput from './Inputs/ResultInput'
    export default {
        components: {
            UserSelect,
            ManagerSelect,
            BrandInput,
            ModelInput,
            IsUsd,
            YearInput,
            GradeInput,
            MileageInput,
            ChassisInput,
            ColorInput,
            TransmissionInput,
            DisplacementInput,
            EquipmentInput,
            AuctionInput,
            DateSelect,
            ScoreInput,
            LotInput,
            ResultInput
        },
        computed: {
            success: function () {
                return this.$store.getters.getNewCarSuccessStatus
            },
            isLoading: function () {
                return this.$store.getters.getNewCarLoadingStatus
            },
            userId: function () {
                return this.$store.getters.getNewCarUser
            }
        },
        methods: {
            createNewCar () {
                this.$store.dispatch('createNewCar')
            },
            backToGarage (userId) {
                this.$router.push({ name: 'EditUser', params: {id: userId }  })
            }
        },
        created () {
            this.$store.dispatch('setNewCarErrorsToDefault')
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/CarCreate.vue